import moment from "moment"
export const secondsFormatDate = (s) => { // 秒转天时分秒
  let d = moment.duration(s, 'seconds')
  Math.floor(d.asDays()) + '天' + d.hours() + '时' + d.minutes() + '分' + d.seconds() + '秒'
  let day = Math.floor(d.asDays()) ? Math.floor(d.asDays()) + '天' : ''
  let hours = d.hours() ? d.hours() + '时' : ''
  let minutes = d.minutes() ? d.minutes() + '分' : ''
  let seconds = d.seconds() ? d.seconds() + '秒' : ''
  return day + hours + minutes + seconds
}
